import React from 'react';
import UlaznaFakturaForma from './UlaznaFakturaForma';

const NovaDevizna = ({ sefZaUnos, naUnesenu, idFakture, naKoKz }) =>
    <UlaznaFakturaForma devizna={true} sefZaUnos={sefZaUnos} naUnesenu={naUnesenu} idFakture={idFakture} naKoKz={naKoKz} />;

export default NovaDevizna;
